import { useEffect } from 'react';
import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../constants';
import {
  APIResponseDevelopersType,
  ResponseDataType,
  DevelopersPropsType,
} from './fetch-developers.types';

export const useAPIFetchDevelopers = (
  params: DevelopersPropsType
): APIResponseDevelopersType => {
  const { data, response, get, error, loading } = useFetch(
    API_ROUTES.DEVELOPERS,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  async function fetchDevelopers(params: DevelopersPropsType): Promise<void> {
    const queryParams = new URLSearchParams(params).toString();
    const data = await get(`?${queryParams}`);

    return data;
  }
  // eslint-disable-next-line
  useEffect(() => {
    fetchDevelopers(params);
  }, []);

  return {
    data: data?.data,
    loading,
    error,
    loaded: response?.ok,
    fetchDevelopers,
  };
};
